



















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import { time } from '@/util/adapter';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
const uuidv4 = require('uuid/v4');
import { ActivityType } from './config';
const { VUE_APP_FCREST: FCREST, VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  activity: `${FCAPI}/shang/promotion/activity`,
  distribution: `${FCREST}/promotion/shang/clerk`, // 分销员列表
  region: `${FCREST}/promotion/shang/region`,
  merchant_clerk: `${FCREST}/promotion/shang/merchant`,
};
const SKETCH_MAX_LENGTH: number = 40;
const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};

// interface 接口定义 用来检测数据类型
interface Form {
  name: string; // 活动名称
  address: string; // 地点
  activity_type: ActivityType; // 活动类型
  // region_id: any[];     // 活动区域
  start_time: Moment[]; // 活动启动时间
  end_time: Moment[]; // 活动结束时间
}
// 必填项
interface Validator {
  field: string;
  validate: (value: any, avtivity: Form) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}

// 必填项提示信息列表
function getValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'name',
      validate: (value: string): boolean => !!value,
      message: '请输入活动名称',
    },
    // {
    //   field: 'region_id',
    //   validate: (value: string[]): boolean => !!value && value.length > 0,
    //   message: '请选择活动区域',
    // },
    {
      field: 'show_time',
      validate: (value: string): boolean => !!value,
      message: '请输入时间描述',
    },
    {
      field: 'start_time',
      validate: (value: string): boolean => !!value,
      message: '请选择活动启动时间',
    },
    {
      field: 'end_time',
      validate: (value: string): boolean => !!value,
      message: '请选择活动结束时间',
    },
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}

@Component
export default class ConfigBase extends Vue {
  isLoading: boolean = false;
  isShowSelectModal: boolean = false;
  isShowDeleteModal: boolean = false;
  activity_id: any = '';
  delete_index: any = '';
  id_list: any = [];
  // table_id_list: any = [];
  send_data: any = {};
  field_watch_list: (() => void)[] = [];
  SKETCH_MAX_LENGTH: number = SKETCH_MAX_LENGTH;
  selectedCheckedList: any = [];
  form: any = {
    activity_type: ActivityType.live,
    show_time: '',
    venue_list: [],
    // region_id: [],
  };
  // nationwide_id: number|undefined; // 活动区域 选项“全国”的 id
  activity_area_list: any = [];
  // clerk_table: any = [];
  member_name: string = '';
  member_mobile: any = '';
  validatorMap: { [field: string]: Validator } = getValidatorMap();
  configFormLayout: any = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
  // tableData: any = {
  //   data: [],
  // };
  modal_data: any = {};
  activity_type: SelectOption[] = [
    {
      label: '直播活动',
      value: ActivityType.live,
    },
    {
      label: '普通活动',
      value: ActivityType.normal,
    },
  ];
  merchant_mobile: any = '';
  venue_visible: boolean = false;
  venue_text: string = '';

  @Watch('form.name')
  onNameChange(val: string, old_val: string) {
    if (val.length > SKETCH_MAX_LENGTH) {
      this.form.name = old_val;
    }
  }

  handleClose(item: string) {
    const venue_list = this.form.venue_list.filter((tag: any) => tag !== item);
    this.form.venue_list = venue_list;
  }

  onChangeTag(e: any) {
    this.venue_text = e.target.value;
  }

  addTag() {
    const venue_text = this.venue_text;
    if (
      venue_text &&
      (this.form.venue_list as any).indexOf(venue_text) === -1
    ) {
      (this.form.venue_list as any) = [...this.form.venue_list, venue_text];
    }
    Object.assign(this, {
      venue_visible: false,
      venue_text: '',
    });
  }

  showAddTagInput() {
    this.venue_visible = true;
    this.$nextTick(() => {
      (this.$refs.input as any).focus();
    });
  }

  // 判断是否有必选项没有填
  validateCommit() {
    const form = this.form as any;
    let is_valid: boolean = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
    }
    return is_valid;
  }

  validate(field: string) {
    const form = this.form as any;
    const is_valid = this.validatorMap[field].validate(form[field], form);
    this.validatorMap[field].status = is_valid ? 'success' : 'error';
    this.validatorMap[field].help = is_valid
      ? ''
      : this.validatorMap[field].message;
    return is_valid;
  }

  handleSelect(selectedRowKeys: any) {
    this.selectedCheckedList = selectedRowKeys;
  }

  // 关闭弹窗
  closeModal() {
    this.selectedCheckedList = [];
    this.member_name = '';
    this.member_mobile = '';
  }

  // 点击下一步
  goPageConfig() {
    if (!this.validateCommit()) {
      return;
    }
    // 第一步新建活动
    const send_data: any = {};
    const profile = storage.getItem('profile') || {};
    send_data.merchant_id = profile.merchant_id;
    send_data.name = this.form.name || '';
    send_data.address = this.form.address || '';
    send_data.activity_type = this.form.activity_type;
    send_data.dian_venue_code = this.form.venue_list;
    // send_data.region_id = this.form.region_id.length > 0 ? this.form.region_id.join(',') : undefined;
    send_data.show_time = this.form.show_time;
    const start_time_stamp: any = this.form.start_time.valueOf();
    const end_time_stamp: any = this.form.end_time.valueOf();
    const start_time: string = JSON.stringify(start_time_stamp / 1000);
    const end_time: string = JSON.stringify(end_time_stamp / 1000);
    send_data.start_time = parseInt(start_time, 10) || '';
    send_data.end_time = parseInt(end_time, 10) || '';
    // send_data.clerk = this.clerk_table || [];
    this.send_data = send_data;
    storage.setItem('activity:send:first', send_data);
    if (send_data.start_time < send_data.end_time) {
      if (!this.$route.query.activity_id) {
        // 新增活动
        this.$router.push({
          path: '/activity/config-second',
          query: {
            activity_type: this.form.activity_type,
          },
        });
      } else {
        // 编辑活动
        this.$router.push({
          path: '/activity/config-second',
          query: {
            activity_id: this.activity_id,
            activity_type: this.form.activity_type,
          },
        });
      }
    } else {
      this.$message.error('开始时间不能晚于结束时间');
    }
  }

  // 获取对应活动的信息
  async getActivityInfo(id: any) {
    this.isLoading = true;
    // await this.getRegion();
    const res = await this.$axios.get(`${API.activity}/${id}`);
    if (res.data.status !== 200) {
      this.isLoading = false;
      this.$message.error(res.data.message);
      return;
    }
    const remote = res.data ? res.data.data : {};
    const venue: string[] = [];
    if (remote.venue.length > 0) {
      remote.venue.forEach((item: any) => {
        venue.push(item.code);
      });
    }
    this.form = {
      name: remote.name,
      address: remote.address,
      activity_type: remote.activity_type || ActivityType.live,
      // region_id: remote.region_id ? remote.region_id.split(',').map((item: string) => Number(item)) : [],
      show_time: remote.show_time || '',
      start_time: moment(remote.start_time * 1000),
      end_time: moment(remote.end_time * 1000),
      venue_list: venue,
    };
    this.isLoading = false;
  }

  async created() {
    // await this.getRegion();
    const profile: any = storage.getItem('profile') || {};
    this.merchant_mobile = profile.mobile || '';
    if (this.$route.query.activity_id) {
      this.activity_id = this.$route.query.activity_id;
      await this.getActivityInfo(this.activity_id);
    }
    this.field_watch_list = _.map(
      this.validatorMap,
      (validator: Validator, field: string) =>
        this.$watch(`form.${field}`, (val: any) => {
          this.validate(field);
        }),
    );
  }

  beforeDestroy() {
    this.field_watch_list.forEach((unwatch: () => void) => unwatch());
  }
}
